<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userInfo.name">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{userInfo.name}}</p>
      <small></small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img key="onlineImg" alt="user-img" src="@/assets/images/elements/user_logo.jpg" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/user-settings').catch(() => {})">

            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">個人資料</span>
          </li>
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">登出</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  data: () => ({
    userInfo:{}

  }),
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout () {

      // if user is logged in via auth0
      if (this.$auth.profile) this.$auth.logOut()

      // if user is logged in via firebase
      const firebaseCurrentUser = firebase.auth().currentUser

      if (firebaseCurrentUser) {
        firebase.auth().signOut().then(() => {
          this.$router.push('/pages/login').catch(() => {})
        })
      }
      // If JWT login
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken')
        this.$router.push('/pages/login').catch(() => {})
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change('admin')
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/pages/login').catch(() => {})
    },
    usertest () {
      console.log(this.userInfo)
    }
  },
  created () {
    const user = firebase.auth().currentUser
    const db = firebase.firestore()
    const userRef = db.collection('user').doc(user.uid)

    // 檢查是否在資料庫內
    userRef.get().then((doc) => {
      if (doc.exists) {
        const getUserData = doc.data()
        this.userInfo = getUserData
      } else {
        // 第一次加入的會先把uid跟email寫入 預設是sales 要admin才可以進去修改
        console.log('尚未有使用者資料')
        userRef.set({
          name: '尚未設定名稱',
          uid: user.uid,
          email:user.email,
          store: '尚未設定',
          rule:'sales'
        })
        this.userInfo = {
          name: '尚未設定名稱',
          uid: user.uid,
          email:user.email,
          store: '尚未設定',
          rule:'sales'
        }
      }
    }).catch(function (error) {
      console.log('Error getting document:', error)
    })
  }

}
</script>
